module.exports = __webpack_public_path__ + "static/media/whatsAppIcon.04b8739f.svg";